export default "__VITE_ASSET__BmFAoFdZ__"